<template>
  <router-view />
</template>

<script>
export default {
  name: "Penagihan",
};
</script>
